// eslint-disable-next-line import/prefer-default-export
import { VerbFetch } from '../VerbFetch';
import { MEDIA_LIBRARY_URL_REGEX, SEGMENT_EVENTS } from '../Constants';

export const validFileExts = [
    'jpeg',
    'jpg',
    'svg',
    'png',
    'gif',
    'tif',
    'docx',
    'doc',
    'pdf',
    'xls',
    'ppt',
    'mp4',
    'avi',
    'mpg',
    'mpeg',
    'wmv',
    'mov',
    'qt'
];

export const checkForValidFileType = (fileName) => validFileExts.includes(fileName.split('.').pop().toLowerCase());

export const checkForMediaLibraryLinkClicks = () => (e) => {
    let currentElement = e.target;

    // goes up the DOM until the <a> element is found
    while (currentElement && currentElement.nodeName !== 'A') {
        currentElement = currentElement.parentNode;
    }

    if (!currentElement) {
        return false;
    }

    const href = currentElement.getAttribute('href') || '';

    if ((href.match(MEDIA_LIBRARY_URL_REGEX) || []).length) {
        e.preventDefault();
        return VerbFetch(`${href}?returnLink=true`).then((url) => window.open(url, '_blank'));
    }
    return false;
};
